import { BemessungssituationState } from "../store/slices/innereSlice";

export function berechneDurchmesserDesRohres(durchmesser, Csol) {
  return Number(durchmesser) + Number(Csol) * 2;
}

export function berechneAchsabstand(durchmesserDesRohres, kantenlaenge) {
  return 3 * Number(durchmesserDesRohres) + Number(kantenlaenge);
}

export function berechneC(durchmesserDesRohres, kantenlaenge) {
  return Number(durchmesserDesRohres) + Number(kantenlaenge);
}

export function berechneWandDicke(bemessungssituation, wanddicke) {
  if (bemessungssituation == BemessungssituationState.DAUERHAFT) return Number(wanddicke);

  if (bemessungssituation == BemessungssituationState.TEMPORÄR) return Number(wanddicke) - 2.2;
}
